<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="filepos3054"><a></a>
<div class="calibre2" style="text-align:center"><img alt="image" class="calibre3" src="images/00001.jpg"/></div>
</div> <div class="mbp_pagebreak" id="calibre_pb_0"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?0361d9b4